<template>
  <v-app>
    <router-view/>
    <session-expired/>
    <notifications/>
    <dialogs/>
  </v-app>
</template>

<script type="module">
  import Notifications from "./components/Helpers/Notifications"
  import Dialogs from "./components/Helpers/Dialogs/Dialogs"
  import SessionExpired from "./components/Helpers/Errors/SessionExpired"

  export default {
    name: "App",
    components: {SessionExpired, Dialogs, Notifications},
    created() {
      // Adicionado event listeners para evitar que quado arrastado um arquivo para a plataforma
      //  o browser tente abri-lo ao largar o arquivo.
      window.addEventListener("drop", function (event) {
        event.preventDefault()
      })
      window.addEventListener("dragover", function (event) {
        event.preventDefault()
      })
    },
  }
</script>
<style lang="sass">
  @import "sass/mixins"
  @import "sass/helpers"
  @import "sass/logos"
  @import "sass/leaflet"
  @import "sass/aero-custom"

  html
    overflow-y: auto !important
</style>
